module.exports = __webpack_public_path__ + "img/mike-berger.121db301.jpg";